import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { createDatasetPromptAction } from '../../actions/ai';

type CreatePromptProps = {
	filename: string
  createDatasetPromptUrl?: string
	prompt: string
  context: string
  messages: any[]
  setMessages: React.Dispatch<React.SetStateAction<any[]>>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  setshowSteps: React.Dispatch<React.SetStateAction<boolean>>
}

const createPrompt = async ({
  filename, createDatasetPromptUrl, prompt, context, messages, setMessages, setLoading, setshowSteps}: CreatePromptProps) => {
  try {
    setMessages(messages => [...messages, prompt]);
    setLoading(true);
    
    const formattedFilename = filename.replace(/ /g, '_')
    const result = await createDatasetPromptAction(
      formattedFilename, 
      {
        prompt,
        context,
      }, 
      createDatasetPromptUrl
    );

    setMessages(messages => [...messages, result || result.message]);
    setshowSteps(result["showSteps"]);
  } catch (err) {
    if (err instanceof AxiosError) {
      toast.error(err.response?.data.message ?? err.message);
    }
    return Promise.reject(err);
  } finally {
    setLoading(false);
  }
};

export default createPrompt;